export class GmAccountInformationQueryParameters {
  SourceCode?: string;
  APIKey?: string;
  'Member Number'?: string | null;
  'Profile Id'?: string | null;
  'Light Content': string;
  ShowContent: string;

  constructor(obj?: Partial<GmAccountInformationQueryParameters>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
